import React, { useMemo } from 'react';
import AssistantChat from './AssistantChat';
import { secFilingChatConfig } from './assistantChatConfigs';

function SecFilingChat(props: { agent?: string; data: any }) {
  const config = useMemo(
    () => secFilingChatConfig(props),
    [props.agent, props.data]
  );
  return <AssistantChat config={config} />;
}

export default SecFilingChat;
